import React, { useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Col, Container, Row } from "react-bootstrap"
import * as styles from "./EventListingPanel.module.scss"

import EventCard from "../../internal/eventCard/EventCard"
import PanelWrapper from "../../internal/panelWrapper/PanelWrapper"
import PaginationControls from "../../internal/paginationControls/PaginationControls"


function TruncateString(str,limit) {
  if(str && str.length > limit) {
    return str.substring(0, limit) + "..."
  }
  return str
}


const PER_PAGE = 6
const EventListingPanel = ({ blok, cardData }) => {
  const cards = [...cardData].sort((a, b) => new Date(a.date.replace(/-/g, "/")) - new Date(b.date.replace(/-/g, "/")))
  const [currentPage, setCurrentPage] = useState(1)

  const numPages = Math.ceil(cards.length / PER_PAGE)

  const handlePageChanged = (page) => {
    setCurrentPage(page)
  }

  return (
    <PanelWrapper blok={blok}>
      <Container>
        <Row>
          <Col xs={12}>
            <Row>
              {cards.length > 0 ? cards.filter((_, idx)=>{
                // Filter current page
                return (idx+1 > ((currentPage-1)*PER_PAGE) && idx+1 <= PER_PAGE*currentPage)
              }).map((card)=>{
                  return(
                <Col xs={12} md={6} key={card.id}>
                  <EventCard
                    image={card.image}
                    thumbnail={card.thumbnail}
                    date={card.date}
                    endDate={card.endDate}
                    location={card.location}
                    headline={card.headline}
                    excerpt={TruncateString(card.excerpt, 120)}
                    cta_text={(<FormattedMessage id="component.panel.story_listing_panel.cta"/>)}
                    cta_link={card.link} />
                </Col>
              )})
              : 
                <div className={styles.no_upcoming_events}>
                  <p>No upcoming events</p>
                </div>
              }
            </Row>
          </Col>
        </Row>
        <div>
          <br/>
          <div style={{float: "right"}}>
            {numPages > 1 ? (
              <PaginationControls numPages={numPages} currentPage={currentPage} onClickPage={handlePageChanged} />
            ) : null}
          </div>
          <div style={{clear: "both"}} />
        </div>
      </Container>
    </PanelWrapper>
  )
}

export default EventListingPanel
